import { Fragment } from 'react'

import { ActivityMenu } from '~/bootcamp/types/bootcamp.types'

import Divider from '~/bootcamp/components/Divider'

import LevelTag from '~/bootcamp/components/LevelTag'

import { getLevelIndexShift } from '~/bootcamp/utils/bootcamp.utils'

import PageProgressBar from './PageProgressBar'
import VideoCourseHeader from './VideoCourseHeader'

interface Props {
  courseLevelKeys: string[]
  courseLevels: Record<number, ActivityMenu[]>
  renderPageCards: (page: ActivityMenu, idx: number) => React.ReactElement
}

const VideoCourseBootcampView = ({ courseLevelKeys, courseLevels, renderPageCards }: Props): React.ReactElement => {
  const levelShift = getLevelIndexShift(courseLevels)
  return (
    <article>
      <PageProgressBar />
      <VideoCourseHeader />
      <section className="max-w-screen-sm mx-auto w-full px-4 pb-4">
        {courseLevelKeys.map((menuLevel, index) => {
          const numericLevel = Number(menuLevel)
          const levelPages: ActivityMenu[] = courseLevels[numericLevel]
          const { levelTag } = levelPages[0]

          return (
            <Fragment key={`menu-${numericLevel}`}>
              {levelTag && index !== 0 ? <Divider /> : null}
              {levelTag ? <LevelTag level={index + levelShift} /> : null}
              {levelPages.map(renderPageCards)}
            </Fragment>
          )
        })}
      </section>
    </article>
  )
}

export default VideoCourseBootcampView
